import api from '@common/api';
import { useEffect, useState } from 'react';

type ViewState = 'loading' | 'success' | 'error';

export function useVerifyEmailViewModel() {
  const [viewState, setViewState] = useState<ViewState>('loading');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (!token) return setViewState('error');

    api
      .verifyEmail(token)
      .then((result) => {
        setViewState(result.success ? 'success' : 'error');
      })
      .catch(() => {
        setViewState('error');
      });
  }, []);

  return { viewState };
}
